import * as React from "react"
import {
  Text,
  HStack,
  Box,
  Image,
} from "@chakra-ui/react"
import { brandConfig } from "./brandConfig"

// Block52 Logo Component
const Block52LogoImage = ({ width = 120, height = 50 }: { width?: number, height?: number }) => {
  return (
    <Box
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      w={`${width}px`}
      h={`${height}px`}
      position="relative"
      transition="all 0.3s ease"
      m={0}
      p={0}
      _hover={{
        transform: "scale(1.05)",
      }}
    >
      <Image
        src='/block52-logo-color.png'
        alt={brandConfig.logo.alt}
        w="100%"
        h="100%"
        objectFit="contain"
        fallback={
          <Text fontSize="xl" fontWeight="bold" color="white">
            B52
          </Text>
        }
      />
    </Box>
  )
}

// Main Logo component
export const Logo = React.forwardRef<HTMLDivElement, any>((props, ref) => {
  return (
    <Box ref={ref} {...props} m={0} p={0}>
      <Block52LogoImage width={120} height={50} />
    </Box>
  )
})

Logo.displayName = 'Logo'

export default Logo;
